module.exports = __webpack_public_path__ + "img/um-logotip-ang.7dabb1cf.png";